import './css/style.css';
import React from 'react';
import jQuery from 'jquery';
import AppSettingsContext from './context.js';
import AppContextMgr from './contextmgr.js';
import MigrationMgr from './migration.js';
import TestimonialsSection from './section.js';
import TestimonialForm from './form.js';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs-ext/plugin/customParseFormat.js';

import * as u from './utils.js'
import {SAMPLE_DATA,SAMPLE_IMAGES} from './sampledata.js';

dayjs.extend(customParseFormat);

/*---------------------------------------------*/

let SAMPLE_CONTENT = undefined;
function getSampleTestimonials(randomContent) {	
	function randomText(minLength,maxLength) {
		let SAMPLE_TEXT = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
		SAMPLE_TEXT = SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT + SAMPLE_TEXT;

		// minLength = 1000;
		maxLength = maxLength || SAMPLE_TEXT.length;
		maxLength = Math.min(SAMPLE_TEXT.length,maxLength);

		let length = minLength + Math.random()*(maxLength-minLength);
		let start = Math.random()*(SAMPLE_TEXT.length-length);

		if (start < 0) start = 0;
		let text = SAMPLE_TEXT.slice(start).slice(0,length).trim();
		return u.capitalize(text);
	}

	if (SAMPLE_CONTENT) {
		return SAMPLE_CONTENT;
	}

	const SAMPLE_TESTIMONIAL_TEXTS = [
		'Your company is truly upstanding and is behind its product 100%. I am so pleased with this product. Just what I was looking for.',
		'Just wanted to let you know that you guys do a really good job. I\'m so glad I decided to work with you!',
		'You are a true life saver, absolutely wonderful! The best products in the market!',
		'This is so great! I\'m absolutely blown away by your service!'
	];

	let sampleImages = u.shuffle(SAMPLE_IMAGES);

	if (randomContent) {
		SAMPLE_CONTENT = u.shuffle(SAMPLE_DATA.users).slice(0,100).map((user,index) => {
			return {
				author_name: `${u.capitalize(randomText(5,10))} ${u.capitalize(randomText(5,50))}`,
				author_image: sampleImages[index % sampleImages.length],
				job_title: randomText(10,30),
				company_name: randomText(10,30),
				company_url: "https://www.google.com",
				date: new Date(),
				text: randomText(50,300),
				rating: Math.random() < 0.5 ? undefined : 5,
				source: ['facebook','twitter','yelp','google',''][Math.floor(Math.random()*5)]
			}
		});

	} else {
		SAMPLE_CONTENT = u.shuffle(SAMPLE_DATA.users).slice(0,100).map((user,index) => {
			return {
				author_name: `${u.capitalize(user.name.first)} ${u.capitalize(user.name.last)}`,
				author_image: sampleImages[index % sampleImages.length],
				job_title: SAMPLE_DATA.jobTitles[Math.floor(Math.random()*SAMPLE_DATA.jobTitles.length)],
				company_name: SAMPLE_DATA.companies[Math.floor(Math.random()*SAMPLE_DATA.companies.length)],
				company_url: "https://www.google.com",
				date: new Date(),
				text: SAMPLE_TESTIMONIAL_TEXTS[index % SAMPLE_TESTIMONIAL_TEXTS.length] + ' ' + SAMPLE_TESTIMONIAL_TEXTS[index % SAMPLE_TESTIMONIAL_TEXTS.length],
				rating: 5,
				source: ['facebook','twitter','yelp','google',''][Math.floor(Math.random()*5)]
			}
		});
	}

	return SAMPLE_CONTENT;
}

/*---------------------------------------------*/

function loadFullstory(uid,sessionID,version) {
	window['_fs_is_outer_script'] = true;
	window['_fs_debug'] = false;
	window['_fs_host'] = 'fullstory.com';
	window['_fs_org'] = 'SG1H1';
	// window['_fs_org'] = 'S04RK';
	window['_fs_namespace'] = 'FS';
	(function(m,n,e,t,l,o,g,y){
		if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
		g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
		o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+window._fs_host+'/s/fs.js';
		y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
		g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
		g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
		g.log = function(a,b) { g("log", [a,b]) };
		g.consent=function(a){g("consent",!arguments.length||a)};
		g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
		g.clearUserCookie=function(){};
	})(window,document,window['_fs_namespace'],'script','user');

	var fs_id = [uid.replace('user_','').slice(0,8),sessionID,'w'].join('-');
	window.FS.identify(fs_id, {displayName:fs_id, inffuseUser:uid, version: version});
}

/*---------------------------------------------*/

class App extends React.Component {
	static contextType = AppSettingsContext;
	
	constructor() {
		super();

		this.updateHeight = this.updateHeight.bind(this);
		this.updateLayout = this.updateLayout.bind(this);
		this.updateData = this.updateData.bind(this);
		this.state = {
			items: null,
			loading: true,
			shouldUpdateLayout: false,
			settingsOpen: false,
			fullstoryRecording: false
		};

		this.contextMgr = new AppContextMgr();
	}
	
	/*-----*/
	
	loadGoogleAnalytics() {
		if (this.inffuse.editing || this.inffuse.project.flag('notracking'))
			return;

		(function(i, s, o, g, r, a, m) {
			i['GoogleAnalyticsObject'] = r; 
			i[r] = i[r] || (function() {
				(i[r].q = i[r].q || []).push(arguments)
			});
			i[r].l = 1*new Date(); 
			a = s.createElement(o);
			m = s.getElementsByTagName(o)[0]; 
			a.async = 1; 
			a.src = g; 
			m.parentNode.insertBefore(a, m)
		})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

		window.ga('create', 'UA-84663562-5', 'auto');
		window.ga('set', 'dimension1', this.inffuse.user.id());
		window.ga('set', 'dimension2', this.inffuse.site.id());
		window.ga('set', 'dimension3', this.inffuse.project ? this.inffuse.project.id() : 'None');
		window.ga('set', 'dimension4', this.inffuse.user.plan());
		window.ga('set', 'dimension5', this.contextMgr.get('template.id'));
		window.ga('set', 'dimension6', this.inffuse.platform);
		window.ga('set', 'dimension7', 'Praise');
		window.ga('send', 'pageview');

		// missing:
		// window.ga('send','event','form','submit');
		// window.ga('send','event','links','social','facebook');
		// window.ga('send','event','links','footer','promo');
	}

	loadFonts() {
		let keys = ['text','name','job_title','link','date','button','title'];
		let fonts = keys.map((key) => this.contextMgr.get(`style.${key}.font.family`))
							.filter((font) => !!font)
							.map((font) => u.capitalize(font)+':400');
		
		let WebFont = require('webfontloader');
		WebFont.load({google: {families: fonts}});
		WebFont.load({google: {families: ['Sacramento']}});
	}
	
	/*-----*/
	
	setSiteColors() {
		let skinColors = window.DEFAULT_WIX_COLORS;

		this.contextMgr.set('style.bg.section',skinColors.SECTION_BG_COLOR);
		this.contextMgr.set('style.bg.testimonial',skinColors.TESTIMONIAL_BG_COLOR);
		this.contextMgr.set('style.bg.box',skinColors.BUBBLE_BG_COLOR);

		this.contextMgr.set('style.testimonial.border.color',skinColors.TESTIMONIAL_BORDER_COLOR);
		this.contextMgr.set('style.bubble.border.color',skinColors.BUBBLE_BORDER_COLOR);

		this.contextMgr.set('style.text.color',skinColors.TESTIMONIAL_TEXT_COLOR);
		this.contextMgr.set('style.name.color',skinColors.NAME_TEXT_COLOR);
		this.contextMgr.set('style.rating.color',skinColors.RATING_STARS_COLOR);
		this.contextMgr.set('style.job_title.color',skinColors.JOB_TEXT_COLOR);
		this.contextMgr.set('style.date.color',skinColors.DATE_TEXT_COLOR);
		this.contextMgr.set('style.icon.color',skinColors.DATE_TEXT_COLOR);
		this.contextMgr.set('style.title.color',skinColors.SECTION_TITLE_TEXT_COLOR);
		
		this.contextMgr.set('style.button.text',skinColors.LOADMORE_TEXT_COLOR);
		this.contextMgr.set('style.button.border.color',skinColors.LOADMORE_BORDER_COLOR);

		this.contextMgr.set('style.form.button.text',skinColors.SUBMIT_TEXT_COLOR);
		this.contextMgr.set('style.form.button.bg',skinColors.SUBMIT_BG_COLOR);

		this.contextMgr.set('layout.slider.arrows.color',skinColors.ARROWS_COLOR);
		this.contextMgr.set('layout.slider.paging.dots.color',skinColors.DOTS_COLOR);

		// font_0 | Title			| Heading 1
		// font_2 | Page-title	| Heading 2
		// font_3 | Heading-XL	| Heading 3
		// font_4 | Heading-L	| Heading 4
		// font_5 | Heading-M	| Heading 5
		// font_6 | Heading-S	| Heading 6
		// font_7 | Body-L		| Paragraph 1
		// font_8 | Body-M		| Paragraph 2
		// font_9 | Body-S		| Paragraph 3

		// Testimonial text font - Paragraph 2 
		// Name font - Paragraph 1 
		// Job title  - Paragraph 2 
		// Link  - Paragraph 2 + Bold
		// Date font - Paragraph 2 
		// Section title font - H5 
		// Button Text - Paragraph 2
	}

	/*-----*/
	
	setSiteTypography(limitSizes) {
		var themes = window.Wix.Styles.getSiteTextPresets();
		Object.keys(themes).forEach((key) => themes[key].family = themes[key].fontFamily);
	
		let heading_m = themes["Heading-M"];
		let body_m = themes["Body-M"];
		let body_l = themes["Body-L"];

		if (limitSizes) {
			switch (this.contextMgr.get('template.id')) {
				case 'card':
					break;
				
				case 'quote':
					let appWidth = document.body.clientWidth;
					let columnWidth = appWidth / this.contextMgr.get('layout.cols');
					
					if (1*body_m.size.replace('px','') > 18)
						body_l.size = '18px';

					this.contextMgr.set('template.quote.textSize',(columnWidth < 400) ? 18 : 24);
					break;

				default:
					if (1*body_l.size.replace('px','') > 20)
						body_l.size = '20px';
					
					if (1*body_m.size.replace('px','') > 18)
						body_m.size = '18px';
					break;
			}
		}
		
		this.contextMgr.set('style.title.font', heading_m);
		this.contextMgr.set('style.text.font', body_m);
		this.contextMgr.set('style.name.font', body_l);
		this.contextMgr.set('style.job_title.font', body_m);
		this.contextMgr.set('style.link.font', body_m);
		this.contextMgr.set('style.date.font', body_m);
		this.contextMgr.set('style.button.font', body_m);
		this.contextMgr.set('style.form.button.font',body_m);
	}

	/*-----*/

	setItems(items) {
		let asTimestamp = (value) => {
			if (typeof value === "number") {
				return value;
			}

			let date = dayjs(value);
			if (!date.isValid()) {
				date = dayjs(value,"DD/MM/YYYY");
			}

			if (!date.isValid()) {
				return 0;
			}

			return date.valueOf();
		}

		// if editing - multiple updateData() are possible, so we don't want to modify the source data
		if (this.inffuse.editing) {
			items = JSON.parse(JSON.stringify(items));
		}

		let order = this.contextMgr.get('order');
		switch (order) {
			case "random":
				items = u.shuffle(items);
				break;

			case "date-desc":
			case "date-asc":
				items = items.sort(function(a, b) {
					var dir = (order === 'date-desc') ? -1 : 1;
					var a_date = asTimestamp(a.date); // date=undefined messes up the entire mechanism
					var b_date = asTimestamp(b.date);
					if (a_date < b_date) return -1 * dir;
					if (a_date > b_date) return 1 * dir;
					return 0;
				});
				break;
			
			default:
				break;
		}

		let contentLimit = this.contextMgr.get('content.limit.enabled');
		if (contentLimit) {
			let count = 1*this.contextMgr.get('content.limit.count') || 1;
			items = items.slice(0,count);
		}
		// items = items.slice(0,1);
		
		// support line breaks in testimonials text
		items.forEach((t) => {
			if (t.text) {
				t.text = t.text.split(/(?:\\n|&lt;br&gt;|<br>)/).map((line,index,lines) => {
					let newline = (index < lines.length-1) ? <br/> : null;
					
					// let urlRegex = /(https?:\/\/[^\s\(\)\<\>]+)/g;
					// let parts = line.split(urlRegex);
					// for (let i = 1; i < parts.length; i += 2) {
					// 	parts[i] = <a key={'link'+i} href={parts[i]}>{parts[i]}</a>
					// }

					return <span key={index}>{line}{newline}</span>
				})
			}
		});

		this.setState({items: items});
		// this.loadFonts();
	}

	/*-----*/
	
	updateData(settings) {
		let items = this.inffuse.project.get('items');
		if (!items || !items.length) {
			let randomContent = this.inffuse.project.flag('local');
			items = getSampleTestimonials(randomContent).slice(0,2);
		}

		window.NORMALIZE_CONTENT(items);
		
		settings = settings || this.inffuse.project.get('settings.v2');
		if (!settings) {
			this.contextMgr.update(
				JSON.parse(JSON.stringify(window.DEFAULT_APP_SETTINGS.desktop)), 
				JSON.parse(JSON.stringify(window.DEFAULT_APP_SETTINGS.mobile))
			);

			let legacySettings = this.inffuse.project.get('settings');
			if (legacySettings) {
				MigrationMgr.import(legacySettings,items.length,this.contextMgr);
				if (this.inffuse.editing && !this.inffuse.project.flag('local')) {
					this.inffuse.project.set('settings.v2',{
						'data-version': '1.1',
						desktop: this.contextMgr.desktopSettings,
						mobile: this.contextMgr.mobileSettings,
						user: {
							email: window.U.getSafe(legacySettings,'collect.email')
						}
					});

				}
				
				if (typeof window.Wix != 'undefined' && window.Wix.Styles) {
					window.Wix.Styles.getStyleParams(() => {
						this.setSiteTypography(true);
					});
				}

			} else {
				if (typeof window.Wix != 'undefined' && window.Wix.Utils.getViewMode() === 'editor')
					window.Wix.resizeComponent({width: 760});

				if (typeof window.Wix != 'undefined' && window.Wix.Styles) {
					window.Wix.Styles.getStyleParams(() => {
						this.setSiteColors();
						this.setSiteTypography();
					});
				}
			}

		} else {
			window.NORMALIZE_DATA(settings);
			this.contextMgr.update(settings.desktop,settings.mobile);
		}

		this.setItems(items);

		// force promo color
		if (typeof window.Wix != 'undefined' && window.Wix.Styles)
			this.contextMgr.set('style.promo',{color: {color: 'color-4', opacity: 1}});

		this.updateLayout();

		// do we need this?
		setTimeout(() => {
			let WebFont = require('webfontloader');
			WebFont.load({google: {families: ['Sacramento']}});
		},1000);

		let settingsKeepaliveTimer = null;
		this.inffuse.on("settings-keepalive",(params) => {
			if (this.inffuse.project.flag('notracking')) {
				return;
			}

			if (this.inffuse.project.flag('praise_beta') !== 'auto') {
				return;
			}

			if (typeof FS === 'undefined') {
				loadFullstory(this.inffuse.user.id(),params.session,this.inffuse.project.flag('praise_beta'));
				window.FS.shutdown();
				window.FS.restart();
			
			} else if (!this.state.fullstoryRecording) {
				this.setState({fullstoryRecording: true});
				window.FS.shutdown();
				window.FS.restart();
			}

			settingsKeepaliveTimer && clearTimeout(settingsKeepaliveTimer);
			settingsKeepaliveTimer = setTimeout(() => {
				this.setState({fullstoryRecording: false});
				window.FS.shutdown();
				
				settingsKeepaliveTimer = null;
			},3000);
		});
	}
	
	/*-----*/
	
	componentWillMount() {
		let onInffuseLoaded = (inffuse) => {
			window.inffuse = inffuse;
			this.inffuse = inffuse;
			
			this.inffuse.on('data-changed', (data) => this.updateData(data['settings.v2']));
			this.updateData();

			this.loadGoogleAnalytics()
			this.setState({loading: false});
		}

		var app = 'testimonials';
		var server = '//platform.getpraise.co';
		if (document.location.host.indexOf('alpha') !== -1 || document.location.host.indexOf('xbeta') !== -1) {
			app = 'testimonials_alpha';
			
		} else if (document.location.host.indexOf('local') !== -1) {
			// server = "https://localhost:10098";
			// server = "http://localhost:10099";
		}

		window.inffuseSDK = new window.InffuseSDK_01(jQuery.ajax,app);
		window.inffuseSDK.server = server;

		let inffuseContext = u.getLocal(document.location.search) && JSON.parse(u.getLocal(document.location.search));
		let ts = inffuseContext && inffuseContext.ts;
		if (1*(new Date()) - ts < 5000) {
			window.inffuseSDK.initWithContext(inffuseContext.data,onInffuseLoaded);
			u.deleteLocal(document.location.search);
			
		} else {
			window.inffuseSDK.init(onInffuseLoaded);
		}
	}
	
	/*-----*/

	updateHeight() {
		u.debounce(() => {
			this.inffuse && this.inffuse.project.updateHeight();
			setTimeout(() => this.inffuse && this.inffuse.project.updateHeight(),100);
			setTimeout(() => this.inffuse && this.inffuse.project.updateHeight(),500);
			setTimeout(() => this.inffuse && this.inffuse.project.updateHeight(),1000);
		},100);
	}

	updateLayout() {
		this.setState({shouldUpdateLayout: this.state.shouldUpdateLayout+1});
	}

	componentDidMount() {
		var container = document.getElementById('root');
		container.addEventListener("content-changed", this.updateHeight);

		window.onresize = () => u.debounce(() => this.updateLayout(), 250);
	}

	render() {
		if (document.location.pathname === '/form' || document.location.search.indexOf("endpoint=form") >= 0) {
			return (
				<div className={this.state.loading ? 'loading fullscreen' : ''}>
					<AppSettingsContext.Provider value={this.contextMgr}>
						<TestimonialForm />
					</AppSettingsContext.Provider>
				</div>
			)
		}

		if (!this.state || !this.state.items)
			return null;
	
		// update layout on each data change
		this.updateHeight();
		return (
			<AppSettingsContext.Provider value={this.contextMgr}>
				<TestimonialsSection items={this.state.items} shouldUpdate={this.state.shouldUpdateLayout} ></TestimonialsSection>
			</AppSettingsContext.Provider>
		)
	}
}

/*---------------------------------------------*/
/*---------------------------------------------*/

export default App;

window.$ = jQuery;